import React, { useState, useEffect } from 'react'
import axios from 'axios'
import Modal from 'react-modal'
import styled from 'styled-components'
import Recaptcha from 'react-recaptcha'
import { gaEvents } from '../../../analytics/events'
import Cookies from 'universal-cookie'
import { useLocation } from 'react-router-dom'

const modalStyles = {
  overlay: {
    backgroundColor: 'rgba(0, 0, 0, 0.5) !important',
    position: 'fixed !important',
    top: '0 !important',
    left: '0 !important',
    right: '0 !important',
    bottom: '0 !important',
    display: 'flex !important',
    alignItems: 'center !important',
    justifyContent: 'center !important',
    zIndex: '9999 !important',
  },
  content: {
    position: 'relative !important',
    width: '90% !important',
    maxWidth: '400px !important',
    margin: '0 auto !important',
    border: 'none !important',
    borderRadius: '8px !important',
    padding: '20px !important',
    backgroundColor: '#fff !important',
    overflow: 'auto !important',
    maxHeight: '90vh !important',
    boxSizing: 'border-box !important',
  },
}

const FloatingButton = styled.button`
  position: fixed;
  top: 50%;
  right: 10px;
  transform: translate(0, -50%) rotate(-90deg);
  transform-origin: right center;
  background-color: #d9534f;
  color: #fff;
  border: none;
  padding: 6px 18px 20px 44px;
  font-size: 16px;
  border-radius: 5px 5px 0 0;
  cursor: pointer;
  z-index: 10000;

  &::before {
    content: '✉️';
    font-size: 20px;
    position: absolute;
    top: 6px;
    left: 14px;
  }
  &:hover {
    background-color: #c9302c;
  }

  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.2);
`

const ModalContent = styled.div`
  position: relative;
`

const CloseButton = styled.button`
  position: absolute;
  top: 0;
  right: 6px;
  background: transparent;
  border: none;
  font-size: 20px;
  color: #aaa;
  cursor: pointer;

  &:hover {
    color: #333;
  }
`

const RecaptchaWrapper = styled.div`
  text-align: center;

  #g-recaptcha > div {
    margin: 0 auto;
  }
`

const EmailCaptureBox = () => {
  const [isVisible, setIsVisible] = useState(false)
  const [email, setEmail] = useState('')
  const [name, setName] = useState('')
  const [captchaVerified, setCaptchaVerified] = useState(false)
  const [isRecaptchaReady, setIsRecaptchaReady] = useState(false)
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState('')
  const [successMessage, setSuccessMessage] = useState('')
  const cookies = new Cookies()
  const location = useLocation() // Must be at the top level of the component

  const validateEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)

  const loadRecaptchaScript = (callback) => {
    if (!document.getElementById('recaptcha-script')) {
      const script = document.createElement('script')
      script.id = 'recaptcha-script'
      script.src = 'https://www.google.com/recaptcha/api.js?render=explicit'
      script.async = true
      script.defer = true
      script.onload = () => {
        console.log('reCAPTCHA script loaded.')
        if (window.grecaptcha) {
          setIsRecaptchaReady(true) // Update readiness
          if (callback) callback()
        }
      }
      script.onerror = () => {
        console.error('Failed to load reCAPTCHA script.')
      }
      document.body.appendChild(script)
    } else if (window.grecaptcha) {
      setIsRecaptchaReady(true) // Ensure readiness if already loaded
      if (callback) callback()
    }
  }

  const shouldDisplayModal = () => {
    const excludedPaths = [
      '/signup-form',
      '/signup',
      '/signup-complete',
      '/dashboard',
      '/onboarding',
      '/myfreebird',
    ]
    const currentPath = window.location.pathname
    const mailingPopCookie = cookies.get('ml-signup-mailing-list-pop-up')
    return (
      !mailingPopCookie &&
      !excludedPaths.some((path) => currentPath.startsWith(path))
    )
  }

  const shouldDisplayfloatButton = () => {
    const excludedPaths = [
      '/signup-form',
      '/signup',
      '/signup-complete',
      '/dashboard',
      '/onboarding',
      '/myfreebird',
    ]
    const currentPath = window.location.pathname
    return !excludedPaths.some((path) => currentPath.startsWith(path))
  }

  useEffect(() => {
    if (shouldDisplayModal()) {
      const timer = setTimeout(() => setIsVisible(true), 5000)
      return () => clearTimeout(timer)
    } else {
      setIsVisible(false)
    }
  }, [location.pathname])

  useEffect(() => {
    if (isVisible) {
      loadRecaptchaScript(() => {
        if (window.grecaptcha) {
          console.log('reCAPTCHA is ready.')
        }
      })
    }
  }, [isVisible])

  const handleSubmit = async (e) => {
    e.preventDefault()
    setError('')
    if (!name.trim()) return setError('Name is required.')
    if (!validateEmail(email))
      return setError('Please enter a valid email address.')
    if (!captchaVerified)
      return setError('Please complete the reCAPTCHA verification.')

    setLoading(true)
    try {
      const member = {
        user_type: 'mailing-list',
        title: 'Mr',
        firstName: name,
        secondName: 'mailing-list',
        dob: '1968-01-01',
        locationId: null,
        email,
        isVerified: false,
        address_line: '',
        second_address_line: '',
        country_region: '',
        country: '',
        is_new_city: '',
        languages: [],
        discount_code: null,
        landing_page_code: null,
        source_code: null,
        source: 'pop-up',
        price_code: null,
        currency_value: null,
        language_code: null,
        utm_source: null,
        utm_medium: null,
        utm_campaign: null,
        utm_content: null,
      }
      const response = await axios.post('/api/register-member', { member })
      gaEvents.eventGeneric('form_submit', 'submitted', 'Member interest form')
      gaEvents.mailingListSignup(response.data.id)

      await axios.post('/api/ml-signup-mailing-list-pop-up', { member })
      cookies.set('ml-signup-mailing-list-pop-up', 'true', {
        path: '/',
        maxAge: 7 * 24 * 60 * 60,
      })
      setSuccessMessage('Thank you for subscribing!')
      setIsVisible(false)
    } catch (err) {
      console.error(err)
      setError('An error occurred. Please try again.')
    } finally {
      setLoading(false)
    }
  }

  const handleClose = () => {
    cookies.set('ml-signup-mailing-list-pop-up', 'true', {
      path: '/',
      maxAge: 7 * 24 * 60 * 60,
    })
    resetRecaptcha()
    setIsVisible(false)
  }

  const resetRecaptcha = () => {
    if (window.grecaptcha && window.grecaptcha.getResponse().length) {
      window.grecaptcha.reset()
    } else {
      console.warn('No reCAPTCHA client exists to reset.')
    }
  }

  const verifyCallback = (response) => response && setCaptchaVerified(true)

  return (
    <>
      <Modal
        isOpen={isVisible}
        onRequestClose={handleClose}
        style={modalStyles}
        contentLabel="Email Capture Modal"
      >
        <ModalContent>
          <CloseButton onClick={handleClose}>&times;</CloseButton>
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
            }}
          >
            <img
              src="/images/freebird-header-logo-dark.svg"
              alt="Freebird Club Logo"
              style={{
                maxWidth: '100px',
                height: 'auto',
                marginBottom: '10px',
              }}
            />
          </div>
          <h2
            style={{
              color: '#000',
              textAlign: 'center',
              fontFamily: '"Open Sans", sans-serif',
              fontSize: '1.5rem',
              fontWeight: 'bold',
              margin: '0 0 10px',
            }}
          >
            Sign Up to Learn More
          </h2>
          <p
            style={{
              textAlign: 'center',
              fontSize: '1rem',
              color: '#555',
              lineHeight: '160%',
            }}
          >
            Subscribe to our list to learn more about Freebird Club.
          </p>
          <form
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
            }}
            onSubmit={handleSubmit}
          >
            {error && (
              <p style={{ color: 'red', textAlign: 'center' }}>{error}</p>
            )}
            {successMessage && (
              <p style={{ color: 'green', textAlign: 'center' }}>
                {successMessage}
              </p>
            )}
            <input
              type="text"
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder="Enter your name"
              style={{
                width: '100%',
                padding: '10px',
                marginBottom: '15px',
                border: '1px solid #ddd',
                borderRadius: '5px',
                fontSize: '16px',
              }}
              required
            />
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Enter your email"
              required
              style={{
                width: '100%',
                padding: '10px',
                marginBottom: '16px',
                border: '1px solid #ddd',
                borderRadius: '5px',
                fontSize: '16px',
              }}
            />

            <RecaptchaWrapper>
              {isRecaptchaReady ? (
                <Recaptcha
                  sitekey={recaptchaPublicKey}
                  render="explicit"
                  verifyCallback={verifyCallback}
                  id="recaptcha-modal"
                />
              ) : (
                <p>Loading reCAPTCHA...</p>
              )}
            </RecaptchaWrapper>

            <button
              type="submit"
              disabled={loading}
              style={{
                width: '100%',
                padding: '10px',
                backgroundColor: loading ? '#aaa' : '#d9534f',
                color: '#fff',
                fontSize: '16px',
                border: 'none',
                borderRadius: '5px',
                marginTop: '16px',
                cursor: loading ? 'not-allowed' : 'pointer',
              }}
            >
              {loading ? 'Submitting...' : 'Submit'}
            </button>
          </form>
        </ModalContent>
      </Modal>
      {shouldDisplayfloatButton() && !isVisible && (
        <FloatingButton onClick={() => setIsVisible(true)}>
          Subscribe
        </FloatingButton>
      )}
    </>
  )
}

export default EmailCaptureBox
